module.exports = __webpack_public_path__ + "img/H3.e9a7202a.png";